export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-18 bg-gradient-to-br from-primary-500 via-primary-600 to-accent-500">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl text-background-50 mb-3">
              贝勒漫画 APP 下载
            </h2>
            <p className="text-sm text-background-50/80 leading-relaxed mb-6 max-w-lg">
              随时随地畅享漫画阅读体验。支持 iOS 与 Android 双平台，
              离线下载、夜间模式、自动追更等贴心功能，让阅读更自由。
              贝勒漫画官方APP，安全纯净无广告打扰。
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <div className="flex items-center gap-3 px-6 py-3 rounded-xl bg-background-50/15 backdrop-blur-sm border border-background-50/20 cursor-pointer hover:bg-background-50/25 transition-colors">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-apple-fill text-2xl text-background-50"></i>
                </div>
                <div className="text-left">
                  <div className="text-xs text-background-50/70">iOS 版本</div>
                  <div className="text-sm font-medium text-background-50">App Store 下载</div>
                </div>
              </div>

              <div className="flex items-center gap-3 px-6 py-3 rounded-xl bg-background-50/15 backdrop-blur-sm border border-background-50/20 cursor-pointer hover:bg-background-50/25 transition-colors">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-android-fill text-2xl text-background-50"></i>
                </div>
                <div className="text-left">
                  <div className="text-xs text-background-50/70">Android 版本</div>
                  <div className="text-sm font-medium text-background-50">APK 下载</div>
                </div>
              </div>
            </div>

            <div className="mt-5 flex items-center justify-center lg:justify-start gap-3 text-xs text-background-50/70">
              <span className="flex items-center gap-1">
                <i className="ri-shield-check-line"></i> 官方正版
              </span>
              <span>·</span>
              <span className="flex items-center gap-1">
                <i className="ri-smartphone-line"></i> 多端同步
              </span>
              <span>·</span>
              <span className="flex items-center gap-1">
                <i className="ri-moon-line"></i> 夜间模式
              </span>
            </div>
          </div>

          <div className="flex-shrink-0 w-56 md:w-64">
            <div className="relative aspect-[9/16] rounded-3xl overflow-hidden bg-background-200 border-4 border-background-50/30">
              <img
                src="https://readdy.ai/api/search-image?query=A%20clean%20modern%20smartphone%20app%20mockup%20showing%20a%20comic%20reading%20interface%20on%20a%20phone%20screen%2C%20displaying%20a%20manga%20page%20with%20colorful%20illustrations%20and%20speech%20bubbles%2C%20warm%20reading%20mode%20theme%20with%20soft%20background%2C%20minimal%20UI%20elements%20at%20bottom%2C%20clean%20phone%20frame%2C%20product%20photography%20style%20with%20soft%20lighting%2C%20cozy%20atmosphere&width=576&height=1024&seq=app-mockup-beile&orientation=portrait"
                alt="贝勒漫画APP手机阅读界面"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}